export const charactersRemaining = (str: string | undefined, maxLength: number): number => {
    if (!str) {
        return maxLength;
    }

    return maxLength - str.length;
};
